import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./ManagePaymentsView.component.css";
import { getAuthToken } from "../../../api/auth/auth";
import { Link } from "react-router-dom";
import { AppLinks } from "../../../constants/app-links";
import Loader from "../../common/loader/Loader";


export class ManagePaymentsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPaymentPage: false,
            enrolledAutoPay: false,
        }
    }
    
    closeManagePayments = () => {
        this.props.closeManagePayments();
    }

    componentDidMount() {
       
        var self = this;
        this.setState({ loadingPaymentPage: true });
       
        // receive messages from iframe
        var eventMethod = window.addEventListener
            ? "addEventListener"
            : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent"
            ? "onmessage"
            : "message";

        eventer(messageEvent, function (e) {
            
            console.log('Message from iframe just came: ' + e.data);
        
            switch (e.data.action) {
                case "error":
                    break;
                case "enrollAutoPayComplete":
                    // self.handleFormSubmit();
                    // self.closeManagePayments();
                    self.setState({ enrolledAutoPay: true });
                    break;
                case "updateAutoPayComplete":
                    self.setState({ enrolledAutoPay: true });
                    break;
                case "enrollAutoPayCanceled":
                    self.closeManagePayments();
                    break;
                case "updateAutoPayCanceled":
                    self.closeManagePayments();
                    break;
                case "portalOne.unload":
                    if (self.state.enrolledAutoPay) {
                        self.handleFormSubmit();
                    }
                    self.closeManagePayments();
                    break;
                case "documentReady":
                    self.setState({ loadingPaymentPage: false });
                    break;
                case "portalOne.error":
                    break;
                default:
                    break;
            }
        });
    }

    handleFormSubmit() {
        console.log('now in handleFormSubmit');
        this.props.updateBilling(this.props.userAccountDetails.AccountID);
      }

    paymentPageIframe(userData) {

        var iFramePath = process.env.REACT_APP_PLAIN_APIURL + "/Payments/PaymentPage?modal=" + this.props.managePaymentsAction + "&token=" + getAuthToken();
       
        return(
            <div>
                <iframe title="Payment Page" src={iFramePath} id="paymentPageIframe" className="paymentPageIframe" ></iframe>
            <br />
            </div>
        );
    }

    render() {
        return (
          <div className="manage-payments">
                { this.paymentPageIframe(this.props.userAccountDetails) }
                {(this.state.loadingPaymentPage) && (
                    <Loader position="absolute" fullPage={true} zIndex="300" />
                )}
          </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
    },
    dispatch
  )
});

export default connect(
  mapDispatchToProps
)(ManagePaymentsView);

